export const Z_HEIGHTS = {
  BACKDROP: 999,
  CARD_FOOTBALL: 10,
  MODAL: 1000,
  NAVBAR: 100,
  ALERT: 101,
};

export const HEIGHTS = {
  BOTTOM_TICKER: '40px',
  NAVBAR_DESKTOP: '4rem',
  NAVBAR_TABLET: '5.5rem',
};

export const SCREEN_WIDTHS = {
  MOBILE: 'max-width: 767px',
  TABLET: 'max-width: 1023px',
  DESKTOP: 'max-width: 1279px',
};

export const DURATIONS = {
  POPUP_ALERT: 3000,
};
